module.exports = __webpack_public_path__ + "img/xx.c7851f19.svg";